export const BRAND = {
  name: "Cross Jobs",
  color: "#1E3A5F",
  accent: "#EA580C",
  mark: "/crossjobs-mark.png",
};

export const BRAND_SWATCHES = [
  "#1E3A5F", "#0F172A", "#1D4ED8", "#0F766E", "#15803D",
  "#B91C1C", "#EA580C", "#7E22CE", "#BE185D", "#44403C",
];

const HEX = /^#[0-9a-f]{6}$/i;

const channels = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => c / 255);
};

export function hexToHsl(hex) {
  const [r, g, b] = channels(hex);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return [Math.round(h), Math.round(s * 100), Math.round(l * 100)];
}

// Same rule as the backend: white text must keep a 3:1 contrast on the colour.
export function isDarkEnough(hex) {
  if (!HEX.test(hex || "")) return false;
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const [r, g, b] = channels(hex).map(lin);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b <= 0.3;
}

export function applyBrandColor(hex) {
  const color = HEX.test(hex || "") ? hex : BRAND.color;
  const [h, s, l] = hexToHsl(color);
  const root = document.documentElement.style;
  root.setProperty("--brand-h", String(h));
  root.setProperty("--brand-s", `${s}%`);
  root.setProperty("--brand-l", `${l}%`);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", color);
}
